import { render, staticRenderFns } from "./accountCenter.vue?vue&type=template&id=3246c49c&scoped=true"
import script from "./accountCenter.vue?vue&type=script&lang=js"
export * from "./accountCenter.vue?vue&type=script&lang=js"
import style0 from "./accountCenter.vue?vue&type=style&index=0&id=3246c49c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246c49c",
  null
  
)

export default component.exports